module.exports = __webpack_public_path__ + "img/ic-back-indigo.b1f13f9d.svg";